import React from "react";

import {
    FaqAskQuestionForm,
    FaqAskQuestionFormData,
} from "@/mk2/apps/faq/components/FaqAskQuestionForm";
import { Interpolate } from "@/mk2/components/Interpolate";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { FAQ_FORM_OUTDATED_BROWSER } from "@/mk/autogenerated/translations/FaqAskQuestion.2abda00dc9c3faab97d801a4978c44f8";

import styles from "./FaqAskQuestion.mscss";
import { Props } from "./FaqAskQuestionPage";

class FaqAskQuestion extends React.Component<Props> {
    public render() {
        const { loadingState, question } = this.props;

        return (
            <div className={styles.FaqAskQuestion}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderLoadSuccess}
                    hasData={!!question}
                />
            </div>
        );
    }

    private load = () => {
        const { faqId, onLoad } = this.props;
        onLoad(faqId);
    };

    private renderLoadSuccess = () => {
        const { initialValues, isMobile, question, requestUser } = this.props;

        return (
            <div>
                <FaqAskQuestionForm
                    initialValues={initialValues}
                    isMobile={isMobile}
                    onSave={this.handleOnSave}
                    question={question}
                    requestUser={requestUser}
                />
            </div>
        );
    };

    private handleOnSave = (values: FaqAskQuestionFormData) => {
        const { faqId, onSave } = this.props;
        onSave(faqId, values);
    };
}

export default FaqAskQuestion;
